import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class Alertreportservice {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
  ) { }




  getAlarmTypes(userAccount): Promise<any> {
    // const idPlate = '861693033912148';
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getAlarmTypes/';
    return this.http.get(url, { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8' } })
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getDrivers(): Promise<any> {
    // const idPlate = '861693033912148';
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getDriversList/' + this.commonService.getUserName();
    return this.http.get(url, { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8' } })
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getDrivers_rol(): Promise<any> {
    // const idPlate = '861693033912148';
    const url = this.commonService.getPrefixUrlService() + 'Service.svc/getDriversList_rol/' + this.commonService.getUserName() + "/" +this.commonService.getUserRole();
    return this.http.get(url, { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8' } })
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }

  getReport(plates, alarmTypes, drivers, dateIni, dateFin): Promise<any> {
    dateFin = dateFin.toString().replace('T', ' ')
    // const url = this.commonService.getPrefixUrlService() + 'Service.svc/getAlarmReport/' + plates + '/' + alarmTypes + '/' + drivers + '/' + dateIni + '/' + dateFin;
    // this.http.get(url, { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=UTF-8' } })
    //   .toPromise()
    //   .then(obj => {
    //     const response = JSON.parse(obj.toString());
    //     return response;
    //   });
      var data = {
        user_account : this.commonService.getUserName(),
        plates : plates, 
        alarmTypes : alarmTypes, 
        drivers : drivers, 
        dateIni : dateIni, 
        dateFin : dateFin
      }
      return this.http.post(this.commonService.getPrefixUrlService() + 'Service.svc/getAlarmReport',
      JSON.stringify(data), {headers: {'Accept': 'application/json', 'Content-Type': 'application/json; ; charset=UTF-8'}})
      .toPromise()
      .then(obj => {
        const response = JSON.parse(obj.toString());
        return response;
      });
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/alertreport.service.ts